import { useEffect } from "react";
import ServiceCategoryButtons from "@/components/ServiceCategoryButtons";
import ServicesWithTabs from "@/components/ServicesWithTabs";
import AISoftwareSection from "@/components/AISoftwareSection";
import Contact from "@/components/Contact";

const ServicesPage = () => {
  useEffect(() => {
    document.title = "Our Services - E-commerce Onboarding | Myntra, Nykaa, Ajio, Blinkit | BrandBorn";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "BrandBorn offers complete e-commerce onboarding services for 70+ platforms including Myntra, Nykaa, Ajio, Blinkit, Swiggy Instamart, Amazon, Flipkart. Starter, Premium, Quick Commerce, Luxe & International packages.");
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-16" data-testid="services-page">
      <section className="bg-black text-white py-16 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4">
            Our <span className="text-red-500">Services</span>
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Complete e-commerce onboarding solutions for <strong>70+ marketplaces</strong> — from Myntra to Blinkit, Nykaa to Amazon. Get your brand approved and selling in just 14 days.
          </p>
        </div>
      </section>
      <ServiceCategoryButtons />
      <ServicesWithTabs />
      <AISoftwareSection />
      <Contact />
    </div>
  );
};

export default ServicesPage;
